<template>
    <div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    name: 'Caslogin',
    data() {
        return {
            token: ''
        }
    },
    created() {
        console.log('到达中转页面')
        this.token = this.$functions.getQueryString('token');
        this.getData()
    },
    methods: {
		getData(){
            let that = this
            $.ajax({
                //请求方式
                type: "GET",
                async: false,
                //请求的媒体类型
                contentType: "application/json;charset=UTF-8",
                //请求地址
                url: `${this.$config.service.futianlogin}?token=${this.token}`,
                //数据，json字符串
                //data : JSON.stringify(list),
                //请求成功
                success: function(result) {
                    // console.log(result)
                    if (result.code == 0) {
                        let userInfo = JSON.stringify(result.resultBody);
                        window.localStorage.setItem('userInfo', userInfo);
                        window.localStorage.setItem('token', result.resultBody.token);
                        that.$message.success('登录成功');
                        if (that.$route.query.redirect != undefined) {
                            that.$router.push(that.$route.query.redirect);
                        } else {
                            that.$router.push({ path: '/my' });
                        }
                    } else if (result.code == 1001) {
                        window.location.href = result.message
                    }
                },
                //请求失败，包含具体的错误信息
                error: function(e) {
                    console.log(error);
                }
            });
        }
    }
}
</script>
